import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { PageLoading } from '@/components/shared/Loading'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { user, loading } = useAuthStore()

  if (loading) return <PageLoading />
  if (!user) return <Navigate to="/login" replace />

  return <>{children}</>
}
